module.exports = __webpack_public_path__ + "img/index-solutions-embed.986dba64.png";